import React from 'react';
import { RICH_TEXT_OPTIONS } from 'consts/contentful';

import { Faq } from './Faq';
import type { FaqEntry } from 'schema';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export const ContentfulFaq = ({ faqs, body, ...props }: FaqEntry) => (
  <Faq
    {...props}
    body={body && documentToReactComponents(body, RICH_TEXT_OPTIONS)}
    faqs={faqs.map(({ richTextQuestion, answer, ...rest }) => ({
      richTextQuestion: richTextQuestion
        ? documentToReactComponents(richTextQuestion, RICH_TEXT_OPTIONS)
        : '',
      answer: documentToReactComponents(answer, RICH_TEXT_OPTIONS),
      ...rest,
    }))}
  />
);
